import { render, staticRenderFns } from "./SummaryInfoGroup.vue?vue&type=template&id=2b142d04&scoped=true&"
import script from "./SummaryInfoGroup.vue?vue&type=script&lang=js&"
export * from "./SummaryInfoGroup.vue?vue&type=script&lang=js&"
import style0 from "./SummaryInfoGroup.vue?vue&type=style&index=0&id=2b142d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b142d04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
})
